'use client';

import { Suspense, useLayoutEffect } from 'react';
import { useSearchParams } from 'next/navigation';

import { persistAttributionIfPresent } from '@/lib/analytics/attribution';

function captureFromLocation(searchFromRouter: string) {
  if (typeof window === 'undefined') return;
  const liveSearch = window.location.search;
  persistAttributionIfPresent(liveSearch || (searchFromRouter ? `?${searchFromRouter}` : ''));
}

function AttributionCaptureInner() {
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  useLayoutEffect(() => {
    captureFromLocation(search);
  }, [search]);

  return null;
}

export function AttributionCapture() {
  return (
    <Suspense fallback={null}>
      <AttributionCaptureInner />
    </Suspense>
  );
}
